<template>
    <v-container class="pa-5" fluid>
        <page-title>Produkty</page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col sm="auto">
                            <v-checkbox
                                v-model="filters.hasProductTypeComponents"
                                label="Ukryj rozpisane"
                                hide-details
                                class="mt-2"
                                true-value="false"
                                false-value=""
                                @change="changeFilter"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="3" xl="2">
                            <v-text-field
                                v-model="filters.name"
                                append-icon="mdi-magnify"
                                label="Szukaj..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('name')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="products"
                        :loading="productsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :mobile-breakpoint="0"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :item-class="setSelectedRow"
                        name="productsData"
                        @pagination="updatePagination"
                    >
                        <template #item.name="{item}">
                            {{ item.name }}
                        </template>
                        <template #item.hasProductTypeComponents="{item}">
                            <v-icon
                                v-if="item.hasProductTypeComponents"
                                small
                                color="success"
                            >
                                mdi-check
                            </v-icon>
                            <v-icon v-else small color="error">
                                mdi-close
                            </v-icon>
                        </template>
                        <template #item.actions="{item}">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        icon
                                        data-sentry-label="Otwórz"
                                        v-on="on"
                                        @click="openProduct(item.id)"
                                    >
                                        <v-icon color="teal">
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Edytuj</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'
import PageTitle from '@/components/common/PageTitle'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'Products',
    components: {
        PageTitle
    },
    mixins: [
        pagination,
        tooltipDelay,
        filters,
        dataTableClassSetter
    ],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('configurations/clearProductsFilters')
            this.clearSelectedListItemId()
        }
        next()
    },
    data() {
        return {
            filters: {
                name: null
            },
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Czy rozpisany?',
                    value: 'hasProductTypeComponents',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        products() {
            return this.$store.state.configurations.products.products
        },
        productsLoading() {
            return this.$store.state.configurations.products.productsLoading
        },
        savedFilters() {
            return this.$store.state.configurations.products.filters
        },
        selectedProductId() {
            return this.$store.state.common.selectedListItemId
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    mounted() {
        this.getProducts()
    },
    methods: {
        setSelectedRow(item) {
            if (item.id === this.selectedProductId) {
                return 'isSelected'
            }
        },
        getProducts() {
            this.$store.dispatch('configurations/getProducts', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        openProduct(productId) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(productId)
            router.push({
                name: 'configurationsProductsProduct',
                params: {
                    id: productId
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter() {
            this.$store.dispatch('configurations/setProductsFilters', this.filters)
            this.resetPagination()
            this.getProducts()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getProducts()
            }
            this.clearPaginationPending()
        },
    }
}
</script>

